import React from "react";
import collapse from '../../../images/collapse.svg'
import camera from '../../../images/camera.svg'
import styles from './feature-description.module.css'
import panelButtonStyles from '../panel-button/panel-button.module.css'
import { useDispatch, useSelector } from "react-redux";
import { focusOnSelectedEntity } from "../../../services/actions/map";
import { unSelect } from "../../../services/reducers/map";

export default function FeatureDescription() {
    const dispatch = useDispatch();
    const { selectedFeature, selectedLayer } = useSelector(state => state.map);
    return (<>
            <div className={`${styles.featureDescriptionContainer} ${!selectedFeature.visible ? styles.collapsed : ''}`}>
                <div className={styles.featureDescriptionHeader}>
                    <div className={panelButtonStyles.panelButton} onClick={() => dispatch(focusOnSelectedEntity())}>
                        <img src={camera} alt="focus" />
                    </div>
                    <div className={styles.featureDescriptionLabel}>{selectedLayer?.label}</div>
                    <div className={panelButtonStyles.panelButton} onClick={() =>dispatch(unSelect())}>
                        <img style={{ transform: "rotate(-90deg)" }} src={collapse} alt="hide"/>
                    </div>
                </div>
                {selectedFeature.feature &&
                    <div className={styles.featureDescription}>
                        <table>
                            <tbody>
                                {Object.keys(selectedFeature.feature).map(key =>
                                (
                                    <tr key={key}>
                                        <th>{key}</th>
                                        <td>{selectedFeature.feature[key]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
    </>);
}